import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEllipsisVertical,
  faShareNodes,
  faUpRightFromSquare,
} from '@fortawesome/free-solid-svg-icons';
import { NewsWidget } from '@/core/widgets/model/news-widget';
import { MenuList, MenuListItem } from '@/shared/components/export';
import { useWidgetActions, WidgetChromeContext } from '@/core/widgets/hooks/use-widget-actions';
import '@/core/widgets/components/widget-toolbar.scss';

export default function WidgetToolbar({
  widget,
  context,
  widgetPath,
  compact,
}: {
  widget: NewsWidget;
  context: WidgetChromeContext;
  widgetPath?: string;
  /** Smaller trigger padding, for chrome with little vertical room (e.g. the mobile single-widget header). Default false. */
  compact?: boolean;
}) {
  const { canPopout, shareUrl, popout, recordShare } = useWidgetActions(
    widget,
    context,
    widgetPath,
  );

  const copyShareUrl = () => {
    if ('clipboard' in navigator) navigator.clipboard.writeText(shareUrl);
    else document.execCommand('copy', true, shareUrl);
    toast.info('Copied link to clipboard');
  };

  const items: MenuListItem[] = [
    {
      key: 'share',
      label: 'Share',
      icon: faShareNodes,
      onSelect: () => {
        copyShareUrl();
        recordShare();
      },
    },
  ];

  if (canPopout) {
    items.push({
      key: 'open',
      label: 'Expand',
      icon: faUpRightFromSquare,
      onSelect: popout,
    });
  }

  return (
    <widget.headerActions>
      <MenuList
        trigger={<FontAwesomeIcon icon={faEllipsisVertical} />}
        toggleClassName={`btn btn-link text-primary-500${compact ? ' widget-toolbar-toggle-compact' : ' p-2'}`}
        toggleTitle={'More options'}
        align={'right'}
        items={items}
        footer={close => widget.menuActions?.(close)}
      />
    </widget.headerActions>
  );
}
